import { Dispatch } from 'redux';
import { ApiEndpoint } from '../constants/api-endpoints';
import { ApiAction, HttpMethods } from '../models/api-model';
import { apiAction } from './base-api';

export const getNotifications = (clientGuid: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.notification}/identifier/${clientGuid}/type/Alert`,
		onSuccess,
		onFailure,
	});
};


export const patchNotification = (notificationId: number, payload: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.PATCH,
		url: `${ApiEndpoint.notification}/${notificationId}`,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};
